// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Pin{background-color:#c33d2b;border-radius:25px;color:#fff;font-size:.8rem;font-family:\"Montserrat\";height:20px;padding-top:4px;position:relative;text-align:center;transform:translate(-12px, -36px);width:24px}.Pin.clickable{cursor:pointer;transition:all 100ms}.Pin.clickable:hover{transform:translate(-12px, -43px) scale(1.25);z-index:600}.Pin::after{border:10px solid rgba(0,0,0,0);border-top:17px solid #c33d2b;content:\"\";bottom:-21px;left:2px;position:absolute}", ""]);
// Exports
module.exports = exports;
